import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { SOTStartpageViewModel } from '../../models/startpage.model';
import { SOTService } from '../../services';
import { SwiperComponent, SwiperConfigInterface } from 'ngx-swiper-wrapper';
import { Subscription } from 'rxjs';
import { OverlaySpinnerService } from '../../../core/components/overlayspinner/overlaySpiner.service';

/** Dauer der Regestrierung einer Änderung der Produkte bis zum Upgleich der Produckte im Splashscreen */
const IDLE_DURATION_BEFORE_UPDATE_PRODUCTS = 10 * 1000; // 10 sec

@Component({
  selector: "sot-splashscreen",
  templateUrl: "./splashscreen.component.html",
  styleUrls: ["./splashscreen.component.scss"],
  providers: [OverlaySpinnerService],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SplashscreenComponent implements OnInit, OnDestroy, AfterViewInit {

  @ViewChild("SplashSwiper") splashSwiper: SwiperComponent;

  public swiper_config: SwiperConfigInterface = {
    init: true,
    direction: "horizontal",
    slidesPerView: 1,
    spaceBetween: 0,
    loop: true,
    scrollbar: false,
    navigation: false,
    pagination: false,
    allowTouchMove: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false
    }
  };

  public startpageViewModels: SOTStartpageViewModel[]

  private evProductsChangedSubscription: Subscription;
  private idleForProductRefresh: NodeJS.Timer;

  public constructor(private _changeDetectorRef: ChangeDetectorRef
    , private _sotService: SOTService
    , private _overlaySpinnerService: OverlaySpinnerService) {
    console.debug("--- sot-splashscreen constructor")
  }

  public ngOnInit(): void {
    const me = this;
    console.debug("--- sot-splashscreen ngOnInit")

    me.startpageViewModels = me._sotService.GetStartpages();

    // bindung an neue Artikel
    if (me._sotService.ProductsChanged)
      me.startIdleForProductRefresh();
    me.evProductsChangedSubscription = me._sotService.evProductsChanged.subscribe(() => {
      if (me._sotService.ProductsChanged) {
        me.startIdleForProductRefresh();
      } else {
        me.stopIdleForProductRefresh();
      }
    });

    me.PushChanges();
  }

  public ngAfterViewInit(): void {
    // TODO Find a better Event than a Timeout or requery ImageService for URLS and set them directly
    setTimeout(() => {
      if (this.splashSwiper) {
        const swiper = this.splashSwiper.directiveRef.swiper();
        if (swiper) {
          swiper.loopCreate();
          swiper.update();
        }
      }
    }, 2000);
  }

  public ngOnDestroy(): void {
    const me = this;
    console.debug("--- sot-splashscreen ngOnDestroy")

    me.stopIdleForProductRefresh();
    if (me.evProductsChangedSubscription) {
      me.evProductsChangedSubscription.unsubscribe();
    }
  }

  private PushChanges(): void {
    try {
      this._changeDetectorRef.detectChanges();
    } catch (e) {
      this._sotService.coreLogService.error("SplashscreenComponent.PushChanges", "_changeDetectorRef.detectChanges (catch)", e);
    }
  }

  private startIdleForProductRefresh() {
    const me = this;
    me.stopIdleForProductRefresh();
    me.idleForProductRefresh = setTimeout(() => { me.RefreshProducts(); }
      , IDLE_DURATION_BEFORE_UPDATE_PRODUCTS);
  }

  private stopIdleForProductRefresh() {
    clearTimeout(this.idleForProductRefresh);
  }

  private async RefreshProducts(): Promise<void> {
    const me = this;
    me._overlaySpinnerService.ShowLayoutSpinner();
    try {
      await me._sotService.refreshProductData();
    } catch (error) {
      me._sotService.coreLogService.error("SplashscreenComponent.RefreshProducts", "sotService.refreshProductData (catch)", error);
    }
    me._overlaySpinnerService.HideLayoutSpinner();
  }

  public navigateToOrdertype() {
    this._sotService.GoToOrdertype();
  }

  public get showTemplate(): "slider" | "video" | "image" {
    if (this.startpageViewModels.length > 1) {
      return "slider";
    } else if (this.startpageViewModels[0].media_is_video) {
      return "video";
    } else {
      return "image";
    }
  }

}

